var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.005 4.167C6.23 4.167 3.34 6.868 3.34 10a5.28 5.28 0 0 0 1.007 3.083c.161.226.2.517.102.776l-.636 1.697 2.484-.497a.833.833 0 0 1 .52.064 7.385 7.385 0 0 0 3.186.71h.003c3.777 0 6.667-2.701 6.667-5.833s-2.89-5.833-6.667-5.833ZM1.672 10c0-4.231 3.826-7.5 8.333-7.5S18.34 5.769 18.34 10s-3.826 7.5-8.332 7.5h-.002.003-.001a9.052 9.052 0 0 1-3.648-.754l-3.69.738a.833.833 0 0 1-.944-1.11l1.013-2.7A6.905 6.905 0 0 1 1.672 10Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.495 10a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0ZM10.838 10a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0ZM14.167 10a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z",
    fill: "#fff"
  })));
};

export default SvgFeedback;